// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__3EfiX","cardHeader":"Card_cardHeader__23Gb6"};